import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function CourseSummary ({paymentType = 'Faktura'}) {

  const signupContext = useContext(SignupContext)
  const { course, selectedCourseDate, modal } = signupContext

  React.useEffect(() => {
    modal?.addClass('signup-modal--larger-form')

    return () => modal?.removeClass('signup-modal--larger-form')
  }, [modal])

  return (
    <>
      <div className="title title--h4">Valgt kursus</div>
      <div className="text-rows">
        <div className="text-rows__row">
          <p className="text-rows__text-left">Kursus:</p>
          <p className="text-rows__text-right">{course.post_title}</p>
        </div>
        <div className="text-rows__row">
          <p className="text-rows__text-left">Dato:</p>
          <p className="text-rows__text-right">{selectedCourseDate?.start_date ?? 'Vælg dato'}</p>
        </div>
        <div className="text-rows__row">
          <p className="text-rows__text-left">Undervisningsform:</p>
          <p className="text-rows__text-right">{selectedCourseDate?.lection_form ?? 'Vælg dato'}</p>
        </div>
        <div className="text-rows__row">
          <p className="text-rows__text-left">Betalingsform:</p>
          <p className="text-rows__text-right">{paymentType}</p>
        </div>
        <div className="text-rows__row">
          <p className="text-rows__text-left">Totalpris:</p>
          <p className="text-rows__text-right">{selectedCourseDate?.formatted_price_with_currency ?? course.formatted_price_with_currency }</p>
        </div>
      </div>
    </>
  )
}